// extracted by mini-css-extract-plugin
module.exports = {"h1":"titles_h1__3_098","h2":"titles_h2__3IJl9","h3":"titles_h3__2-S19"};